import React from 'react';
import { store } from 'src/feature-app';
import { useIsComerciales } from 'src/feature-app/hooks';
import { OneFormState } from 'src/types';
import { SelectDpsDomain } from '../SelectDpsDomain';
import { InputWrapper } from '../styleComponents';

interface TratoProps {
  paddingTop?: string;
  paddingBottom?: string;
}

export const Trato = (props: TratoProps) => {
	const isComerciales = useIsComerciales();
	const dpsToken = isComerciales ? 'LCV_DDB_FRM_LEM_REC_LEM' : 'VW_DDB_FRM_LEM_REC_LEM';

	return (
		<SelectDpsDomain name="trato" label="Trato" token={dpsToken} domain="Treatment" nodeValue="VALUE" nodeText="VALUE" selected="Sr." required paddingTop={props.paddingTop} paddingBottom={props.paddingBottom}  />
	);
};
